import React from 'react';
import { FC } from 'react';
import { Terminal } from '~/types';
import cx from 'classnames';
import {
  TerminalAndroidIcon,
  TerminalDefaultIcon,
  TerminalECommerceIcon,
  TerminalIosIcon,
  TerminalNotActivatedIcon,
} from '~/img';
import styled from 'styled-components';

interface DeviceIconProps {
  osName?: 'Android' | 'iOS' | string;
  className?: string;
  active: boolean;
  type?: Terminal['terminalType'];
}

const DeviceIcon: FC<DeviceIconProps> = ({ osName, className, active, type }): JSX.Element => {
  const notActivated = <TerminalNotActivatedIcon className={cx(className, 'text-gray')} />;
  if (type === 'ECOMMERCE') return <TerminalECommerceIcon className={className} />;
  if (!active) return notActivated;
  switch (type) {
    default:
      switch (osName) {
        case 'Android':
          return <TerminalAndroidIcon className={className} />;
        case 'iOS':
          return <TerminalIosIcon className={className} />;
        default:
          return <TerminalDefaultIcon className={className} />;
      }
  }
};

export default styled(DeviceIcon)`
  font-size: 80px;
`;
